<div class="grid">

    @for (layoutPage of layoutPages; track layoutPage) {

        <div class="col-4 custom-width">

            @for (layoutSection of templateLayout; track layoutSection) {

                @if (layoutSection.pageNum == layoutPage) {

                    <div class="container mt-6">
                        <!-- <h2 class="ui-card-title">{{layoutSection.sectionName}}</h2> -->
                        <table class="table table-bordered table-striped text-center"
                                id="headers">
                            <tbody>

                                @for (row of layoutSection.slots; track row) {
                                    <tr class="row-style">
                                        @for (slot of row; track slot) {
                                            <td  [attr.id]="slot.slotId"
                                                    [class]="slot.fieldKey ? 'assigned-slot' : 'available-slot'" 
                                                    (dragenter)="onDragEnter($event)" 
                                                    (dragleave)="onDragLeave($event)" 
                                                    (dragover)="onDragOver($event)"
                                                    (dragend)="onDragEnd($event)" 
                                                    (drop)="onDrop($event)"
                                                    [draggable]="slot.fieldKey ? true : false" 
                                                    (dragstart)="onDragStart($event, slot.fieldKey || '0' )" >
                                                <div
                                                    [class]="slot.fieldKey ? 'assigned-slot' : 'available-slot'"
                                                    class="drop-zone d-flex justify-content-between align-items-center"
                                                    style="cursor: grab;">
                                                    <span class="original-label">{{slot.slotName}}</span>
                                                    <span class="dropped-label text-end">{{slot.fieldKey}}</span> 
                                                </div>
                                            </td>
                                        }
                                    </tr>
                                }
                            </tbody>

                        </table>
                    </div>

                }

            }

        </div>

    }



    <div class="col-3 custom-tab-content">

       <div class="container mt-6">
            <h2 class="ui-card-title header-with-switch">
                Available Items
                <p-toggleSwitch inputId= "isToggled" [(ngModel)]="isSortedByFieldOrder" (onChange)="onToggleChange($event.checked)" class="custom-switch"/>
            </h2>
            <table class="table table-bordered table-striped text-left custom-table" id="visibleFields">
                <tbody     
                        (drop)="onDropToAvailable($event)"
                        (dragenter)="onDragEnter($event)" 
                        (dragover)="onDragOver($event)" 
                        (dragend)="onDragEnd($event)" >
                    <tr *ngFor="let item of fieldKeys" (click)="onAvailableRowClick(item)" class="row-style" >
                        <td
                            [draggable]="!item.inUse"
                            (dragstart)="onDragStart($event, item.fieldKey)"
                            [class]="item.inUse ? 'assigned-field-key' : 'available-field-key'">
                            <span>{{ item.fieldKey }}</span>
                            @if (selectedFieldKey === item.fieldKey) {
                                <span class="text-end">
                                    <img src="../../../assets/images/red_checkmark_32x32" width="16" height="16" style="margin-right: 8px;" />
                                </span>
                            }
                        </td>
                    </tr>
                </tbody>
            </table>
       </div>   
<!-- 
        <div class="p-field p-formgroup-inline custom-toggle">
            <label for="isToggled" class="p-mr-2">Sort By Field Order:</label>
            <p-toggleSwitch inputId= "isToggled" [(ngModel)]="isSortedByFieldOrder" (onChange)="onToggleChange($event.checked)"/>
        </div>
 -->


    </div>



 

</div> 


 
 